import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";

import { Loader } from "../../components";
import { useAxios, useComponent } from "../../hooks";
import {
  brandDetailsObject,
  objectFromResponse,
} from "./brand details components/brandDetailObject";
import Form from "./new brand components/Form";

export default function NewBrand() {
  const axios = useAxios();
  const { loader } = useComponent();

  const [formData, setFormData] = useState(brandDetailsObject);

  const [editState, setEditState] = useState(true);

  const { activeBrand, userID, categories, location, languages } = useSelector(
    (state) => state.memberDetails
  );

  useEffect(() => {
    loader.start(2);

    axios({
      url: "/getBrand/" + activeBrand.ID,
      method: "GET",
    }).then((brand) => {
      if (brand.success) {
        axios({
          url: "/user/info?userId=" + userID,
        }).then((response) => {
          if (response.success) {
            let data = { ...brand.data, ...response.data.user };
            setFormData(objectFromResponse(data, "new"));
            loader.apiComplete(2);
          }
        });
      }
    });
  }, [axios, activeBrand.ID, loader, userID, formData.fileName]);

  return (
    <Loader>
      <Form
        component="new"
        formData={formData}
        categories={categories}
        location={location}
        languages={languages}
        editState={editState}
        setEditState={setEditState}
        setFormData={setFormData}
      />
    </Loader>
  );
}
